import { render, staticRenderFns } from "./QLPartenza.vue?vue&type=template&id=30798eb2&scoped=true&"
import script from "./QLPartenza.vue?vue&type=script&lang=js&"
export * from "./QLPartenza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30798eb2",
  null
  
)

export default component.exports